import { Avatar, Box, Button, Paper, Stack, TextField } from "@mui/material"
import ChangePassword from "./ChangePassword"

const UserData = () => {

	return (
		<Paper sx={{martinTop:0, martinBottom:4, marginLeft: 2, marginRight: 4, height:'88vh', display: 'flex', justifyContent: 'center' }} elevation={1}>
			<Stack direction={'column'} spacing={1} padding={2} width={'80%'}>
				{/* <Paper elevation={2} sx={{display: 'flex', flexDirection: 'row', justifyContent: 'center', padding: 2}}>

					<Box sx={{display: 'flex', alignItems: 'center', height: '100%'}}>
						<Avatar sx={{width: 128, height: 128}}/>
					</Box>
					
					<Stack direction={'column'} spacing={1} paddingLeft={2}>
						<TextField 
							label='Nome'
							value={'Alberto Hideki Fujita'}
						/>
						<TextField 
							label='E-mail'
							value={'alberto.fujita@yahoo.com'}
							disabled 
						/>
						<TextField
							label='Username'
							value={'alberto.fujita'}
						/>
						<Button variant="contained">Alterar Dados</Button>
					</Stack>
				</Paper> */}
				<Paper elevation={2}>
					<ChangePassword/>
				</Paper>
			</Stack>
		</Paper>
		
	)
}

export default UserData